import _ from 'underscore';

export default class Connector {
  constructor(bidOptionView, adDistributionView) {
    this.bidOptionView = bidOptionView;
    this.adDistributionView = adDistributionView;

    this.setInHouseStatus(_.result(this.bidOptionView.getState(), 'BidOption'));
    bidOptionView.on('change:BidOption', (bidOption) => {
      this.setInHouseStatus(bidOption);
    });
  }

  stopListening() {
    this.bidOptionView.off('change:BidOption');
  }

  setInHouseStatus(bidType) {
    this.adDistributionView.setInHouseStatus(bidType === 'BidValue');
  }
}
